import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const BillingInfoContainer = lazy(
  () => import('@pages/landing/BillingInfo/components/BillingInfoContainer'),
);
const BillingInfo = lazy(() => import('@pages/landing/BillingInfo'));
const PaymentSucceeded = lazy(
  () => import('@pages/landing/BillingInfo/components/PaymentSucceeded'),
);
const PaymentFailed = lazy(
  () => import('@pages/landing/BillingInfo/components/PaymentFailed'),
);
export const BillingInfoRoutes: RouteObject[] = [
  {
    path: '/billing-info',
    element: (
      <React.Suspense>
        <BillingInfo />
      </React.Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <React.Suspense>
            <BillingInfoContainer />
          </React.Suspense>
        ),
      },
      {
        path: 'success',
        element: (
          <React.Suspense>
            <PaymentSucceeded />
          </React.Suspense>
        ),
      },
      {
        path: 'cancel',
        element: (
          <React.Suspense>
            <PaymentFailed />
          </React.Suspense>
        ),
      },
    ],
  },
];
